export default "__VITE_ASSET__B$LQ5zW5__"